import React, { useState } from "react";
import axiosInstance from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import {
  TextField,
  Button, IconButton,
  InputAdornment,
  Typography,
  CircularProgress, Stack, Box
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LoginPromotionPanel from "../components/LoginPromotionPanel";

const LoginPage = ({ setUserName, setIsAuth }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const redirectTo = localStorage.getItem('redirectAfterLogin') || '/';

  const handleLogin = async (e) => {
    e.preventDefault();
    const trimmedEmail = formData.email.trim();
    const trimmedPassword = formData.password.trim();

    if (!trimmedEmail || !trimmedPassword) {
      setError("メールアドレスとパスワードを入力してください");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const payload = { email: trimmedEmail, password: trimmedPassword };
      const response = await axiosInstance.post('/auth/login', payload);
      setUserName(response.data.user.username);
      setIsAuth(true);
      localStorage.removeItem('redirectAfterLogin');
      navigate(redirectTo);

    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "ログインに失敗しました";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Stack direction={{ xs: "column", md: "row" }} sx={{ minHeight: "100vh", background: '#fff' }}>
      {/* 左：ログインフォーム */}
      <Stack flex={1} alignItems="center" >
        <Box sx={{ width: "100%", maxWidth: 400, p: 3, pt: 5, textAlign: 'center' }}>
          <img
            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_LOGO}`}
            alt="Tendenec"
            style={{ maxWidth: 200, maxHeight: 120, display: 'block', margin: '0 auto 1em' }}
          />

          <form autoComplete="off" onSubmit={handleLogin}>
            <TextField
              label="メールアドレス"
              name="email"
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              size='medium'
              margin="normal"
              required
              inputProps={{ maxLength: 255 }}
            />

            <TextField
              label="パスワード"
              name="password"
              type={passwordVisible ? "text" : "password"}
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              size='medium'
              margin="normal"
              required
              inputProps={{ maxLength: 128 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setPasswordVisible(v => !v)}>
                      {passwordVisible ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {error && (
              <Typography color="error" sx={{ mt: 1, fontWeight: "bold" }}>
                {error}
              </Typography>
            )}
            <Stack spacing={2} my={1} alignItems="center">
              <Button
                type="submit"
                variant="contained"
                sx={{ width: "auto", minWidth: 200 }}
                size="large"
              >
                ログイン
              </Button>
            </Stack>

          </form>
        </Box>
      </Stack>

      {/* 右：宣伝 / ブランドイメージ */}
      <LoginPromotionPanel />

    </Stack>
  );
};

export default LoginPage;
